export const LATCH_LATEST = '__latest'
